import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { facultyTimeTable } from '../../redux/action/facultyAction';
import classnames from 'classnames';
import FacultyHomeHelper from '../../Components/FacultyHomeHelper';
import Loading from '../../Components/Loading';
import { useHistory, Link } from 'react-router-dom';

const FacultyAssignment = () => {
  const store = useSelector((store) => store);
  const dispatch = useDispatch();
  const [section, setSection] = useState('');
  const [year, setYear] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState({});
  const [filteredTimetableData, setFilteredTimetableData] = useState([]);
  const history = useHistory();
  const department = store.faculty.faculty.faculty.department;
  useEffect(() => {
    dispatch(facultyTimeTable({department}));
  }, [department]);

  const formHandler = (e) => {
    e.preventDefault();

    if (year && section) {
      const filteredData = store.faculty.timetableData.filter(
        (facultyData) => facultyData.year === year && facultyData.section === section
      );
      setFilteredTimetableData(filteredData);
    } else {
      setFilteredTimetableData([]); // Clear filter if year or section is not selected
    }
  };

  const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];

  const periods = [
    '1st Period  <small>(9:00 to 9:55)</small>',
    '2nd Period  <small>(9:55 to 10:50)</small>',
    '3rd Period  <small>(11:05 to 11:55)</small>',
    '4th Period  <small>(12:55 to 12:45)</small>',
    '5th Period  <small>(1:15 to 2:10)</small>',
    '6th Period  <small>(2:10 to 3:00)</small>',
    '7th Period  <small>(3:10 to 4:00)</small>',
    'Coaching  <small>(4:10 to 5:30)</small>'
  ];
  const isTimetableDataAvailable =
    store.faculty.timetableData && store.faculty.timetableData.length > 0;

  const sortedTimetableData =
    isTimetableDataAvailable &&
    [...store.faculty.timetableData].sort(
      (a, b) => parseInt(a.semester, 10) - parseInt(b.semester, 10)
    );

  return (
    <div>
      {store.faculty.isAuthenticated ? (
        <>
          <div className="container-fluid p-0">
            <div className="d-flex">
              <div className="print-helper">
                <FacultyHomeHelper />
              </div>
              <div className="mx-1 w-100 ">
                <div className='px-3 py-1 bg-light d-flex align-items-center justify-content-between'>
                  <h3> <img src="/logo192.png" width={'50px'} alt="" /> Time Table</h3>
                  <button onClick={()=> window.print()} type="button" className=" btn-success btn text-light"> <img src="/image/print.svg" lt="" /> Download</button>
                </div>
                <div className="col d-md-flex align-items-center justify-content-between">
                  <form
                    className="d-md-flex align-items-center justify-content-start"
                    noValidate
                    onSubmit={formHandler}
                  >
                    <div className="form-group mx-2 print-helper">
                      <label htmlFor="yearId">Year</label>
                      <select
                        onChange={(e) => setYear(e.target.value)}
                        className={classnames('form-control', {
                          'is-invalid': error.year
                        })}
                        id="yearId"
                      >
                        <option>Select</option>
                        <option value="I">1</option>
                        <option value="II">2</option>
                        <option value="III">3</option>
                        <option value="IV">4</option>
                      </select>
                      {error.year && (
                        <div className="invalid-feedback">{error.year}</div>
                      )}
                    </div>
                    <div className="form-group mx-2 print-helper">
                      <label htmlFor="sectionId">Section</label>
                      <select
                        onChange={(e) => {
                          setSection(e.target.value);
                        }}
                        className={classnames('form-control', {
                          'is-invalid': error.section
                        })}
                        id="sectionId"
                      >
                        <option>Select</option>
                        <option value="A">A</option>
                        <option value="B">B</option>
                        <option value="C">C</option>
                        <option value="D">D</option>
                      </select>
                      {error.section && (
                        <div className="invalid-feedback">{error.section}</div>
                      )}
                    </div>
                    <div className="mt-3">
                      {!isLoading && (
                        <button
                          type="submit"
                          className="btn btn-info btn-block print-helper "
                        >
                          <img
                            src="/image/search.svg"
                            className="mb-1"
                            alt=""
                          />{' '}
                          Search
                        </button>
                      )}
                      {isLoading && (
                        <div
                          className="spinner-border text-primary"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                          </div>
                      )}
                    </div>
                    </form>
                    <button className='btn btn-success print-helper ' > <Link to="/FacultyCreateTimeTable" className='text-light'> <img src="/image/add.svg" alt="" /> Create TimeTable</Link></button>
                  </div>
                  <div className="col m-auto">
                    {isTimetableDataAvailable ? (
                      filteredTimetableData.length > 0 ? (
                        // Render filtered timetable data
                        filteredTimetableData.map((facultyData, facultyIndex) => (
                          <div key={facultyIndex}>
                            <div className="resultT p-2">
                              <h2 className="text-center">TimeTable</h2>
                              <div className="d-flex w-100 justify-content-around mt-3">
                                <h5>Department : {facultyData.department} </h5>
                                <h5>Year : {facultyData.year} </h5>
                                <h5>Semester : {facultyData.semester} </h5>
                                <h5>Section : {facultyData.section} </h5>
                              </div>
                            </div>
                            <table className="table resultT p-2 table-responsive table-striped table-bordered">
                              <thead>
                                <tr className="table resultTcol text-light">
                                  <th width="10%">Day</th>
                                  {periods.map((period, index) => (
                                    <th width="10%" key={index}>
                                      <span dangerouslySetInnerHTML={{ __html: period }} />
                                    </th>
                                  ))}
                                </tr>
                              </thead>
                              <tbody>
                                {daysOfWeek.map((day, dayIndex) => (
                                  <tr key={dayIndex}>
                                    <td>{day}</td>
                                    {periods.map((period, periodIndex) => {
                                      const timetableEntry = facultyData.timetable.find(
                                        (entry) =>
                                          entry.day === day &&
                                          entry.periods[periodIndex].periodName ===
                                            `${periodIndex + 1}st Period`
                                      );
                                      return (
                                        <td key={periodIndex}>
                                          {timetableEntry
                                            ? timetableEntry.periods[periodIndex].content
                                            : 'No data available'}
                                        </td>
                                      );
                                    })}
                                  </tr>
                                ))}
                              </tbody>
                              <small className='bg-success text-light p-1 btn m-1'>
                                <Link to={`/FacultyUpdateTimeTable/${facultyData._id}`} className='text-light'><img src="/image/edit.svg" alt="" /> Edit</Link>
                              </small>
                            </table>
                          </div>
                        ))
                      ) : (
                        // Render all loaded timetable data initially
                        sortedTimetableData.map((facultyData, facultyIndex) => (
                          <div key={facultyIndex}>
                            <div className="resultT p-2">
                              <h2 className="text-center">TimeTable</h2>
                              <div className="d-flex w-100 justify-content-around mt-3">
                                <h5>Department : {facultyData.department} </h5>
                                <h5>Year : {facultyData.year} </h5>
                                <h5>Semester : {facultyData.semester} </h5>
                                <h5>Section : {facultyData.section} </h5>
                              </div>
                            </div>
                            <table className="table resultT p-2 table-responsive table-striped table-bordered">
                              <thead>
                                <tr className="table resultTcol text-light">
                                  <th width="10%">Day</th>
                                  {periods.map((period, index) => (
                                    <th width="10%" key={index}>
                                      <span dangerouslySetInnerHTML={{ __html: period }} />
                                    </th>
                                  ))}
                                </tr>
                              </thead>
                              <tbody>
                                {daysOfWeek.map((day, dayIndex) => (
                                  <tr key={dayIndex}>
                                    <td>{day}</td>
                                    {periods.map((period, periodIndex) => {
                                      const timetableEntry = facultyData.timetable.find(
                                        (entry) =>
                                          entry.day === day &&
                                          entry.periods[periodIndex].periodName ===
                                            `${periodIndex + 1}st Period`
                                      );
                                      return (
                                        <td key={periodIndex}>
                                          {timetableEntry
                                            ? timetableEntry.periods[periodIndex].content
                                            : 'No data available'}
                                        </td>
                                      );
                                    })}
                                  </tr>
                                ))}
                              </tbody>
                              <small className='bg-success text-light p-1 btn m-1'>
                                <Link to={`/FacultyUpdateTimeTable/${facultyData._id}`} className='text-light'><img src="/image/edit.svg" alt="" /> Edit</Link>
                              </small>                            
                              </table>
                          </div>
                        ))
                      )
                    ) : (
                      <Loading />
                    )}
                  </div>
                </div>
              </div>
            </div>
        </>
      ) : (
        history.push('/')
      )}
    </div>
  );
};

export default FacultyAssignment;
